module.exports = __webpack_public_path__ + "static/img/Home02@2x.336c309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home02@2x.png
// module id = iC4J
// module chunks = 1